import { jsx as m } from "react/jsx-runtime";
import { clsx as x } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import t from "./roche-rich-text.module.scss.js";
const p = ({
  children: e,
  isFootnote: r,
  isFooterType: i,
  markup: o,
  slot: s,
  dir: c
}) => {
  const n = {
    ...o && { dangerouslySetInnerHTML: { __html: o } }
  };
  return /* @__PURE__ */ m(
    "div",
    {
      slot: s,
      dir: c,
      ...n,
      className: x(
        t["rich-text"],
        r && t["rich-text--is-footnote"],
        i && t["rich-text--is-footer-type"]
      ),
      children: e
    }
  );
};
export {
  p as RocheUIRichText
};
